import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../Forms/GenericFormContainer';

import {
  lengthValidation60,
  required,
  validateEmail,
  validatePassword,
  validatePhoneNumber,
} from '../Forms/utils';

import {
  CHANGE_LOGIN_TYPE,
  COMPLETE_USER_SIGN_UP,
  RESET_PASSWORD,
  UPDATE_EMAIL_PHONE,
} from './constants';

import {
  REACT_SELECT_INPUT,
  STYLED_PASSWORD,
  STYLED_TEXT,
} from '../Forms/fieldTypes';

const ManageUserComponent = (props) => {
  const { t } = useTransl();

  const { person, actionType, form, onSubmit, initialValues, validate } = props;

  const options = [
    {
      label: t('actions.updateEmailOrPhone'),
      value: UPDATE_EMAIL_PHONE,
    },
    {
      label: t('actions.resetPassword'),
      value: RESET_PASSWORD,
    },
    {
      label: t('actions.changeLoginType'),
      value: CHANGE_LOGIN_TYPE,
    },
    {
      label: t('actions.completeUserSignUp'),
      value: COMPLETE_USER_SIGN_UP,
      isDisabled: !person?.editable,
    },
  ];

  const formData = [
    {
      label: t('actions.selectAction'),
      keyName: 'action',
      validate: [required],
      fieldType: REACT_SELECT_INPUT,
      options,
    },
    {
      label: t('title.email'),
      keyName: 'email',
      fieldType: STYLED_TEXT,
      validate: [validateEmail],
      disabled: !actionType || actionType === RESET_PASSWORD,
    },
    {
      label: t('title.phoneNumber'),
      keyName: 'phoneNumber',
      fieldType: STYLED_TEXT,
      validate: [validatePhoneNumber],
      disabled: !actionType || actionType === RESET_PASSWORD,
    },
    {
      label: t('title.password'),
      keyName: 'password',
      fieldType: STYLED_PASSWORD,
      validate: [validatePassword, lengthValidation60],
      disabled: !actionType || actionType === UPDATE_EMAIL_PHONE,
      fieldNotes: t('errors.password'),
      autoComplete: 'new-password',
    },
    {
      label: t('title.confirmPassword'),
      keyName: 'confirmPassword',
      fieldType: STYLED_PASSWORD,
      validate: [],
      disabled: !actionType || actionType === UPDATE_EMAIL_PHONE,
      autoComplete: 'new-password',
    },
  ];

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      initialValues={initialValues}
      validate={validate}
      title={t('title.manageUser')}
      submitText={t('actions.save')}
      backButton={false}
      isFullWidthForm
      canBeUpdated
      enableReinitialize
    />
  );
};

ManageUserComponent.defaultProps = {
  actionType: null,
  validate: () => {},
};

ManageUserComponent.propTypes = {
  person: PropTypes.instanceOf(Object).isRequired,
  actionType: PropTypes.string,
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  onSubmit: PropTypes.func.isRequired,
  validate: PropTypes.func,
};

export default ManageUserComponent;
